enum NewPatientClaimsEnum {
  Yes = "Yes",
  No = "No",
  Insufficient = "Insufficient"
}

export { NewPatientClaimsEnum };
